module.exports = __webpack_public_path__ + "static/media/portfolio2.afc77013.jpeg";